module.exports = __webpack_public_path__ + "static/img/interpretive-mountings.df77750.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/products/interpretive-mountings.jpg
// module id = 424
// module chunks = 0